module.exports = __webpack_public_path__ + "assets/img/chongqing.b08d473c.png";